import { Entity } from "../helpers/Entity"

export type TriggerableAttributesDto = {
    triggerKey: string
    commandKey: string
    triggerableType: string
    config: object
    isEnabled: boolean
    accountId: string
    createdAt: string
    updatedAt: string
    updatedBy: string
    deletedBy: string
}

export type TriggerableDto = {
    attributes: TriggerableAttributesDto
    id: string
    type: string
}

class Triggerable implements Entity {
    private readonly dto: TriggerableDto

    constructor(dto: TriggerableDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.dto.id != "" && this.dto.type == "triggerables"
    }

    getId(): string {
        return this.dto.id
    }

    isEnabled(): boolean {
        return this.dto.attributes.isEnabled
    }
}

export default Triggerable


// WEBPACK FOOTER //
// ./src/state/triggerable/Triggerable.ts